import * as React from 'react';
import { DropdownEntity } from './DropdownEntity';
import { DiagnosisEnergyUseReadDTO } from '../../generated/api-client';
import { apiClient } from '../../services/apiClient';

/** Valore speciale per l'opzione "Tutti gli usi energetici"; in salvataggio imposta all_energy_use a true */
export const ALL_ENERGY_USE_VALUE = 'all';

const ALL_ENERGY_USE_OPTION: DiagnosisEnergyUseReadDTO = {
  id: ALL_ENERGY_USE_VALUE,
  code: 'Tutti gli usi energetici',
} as DiagnosisEnergyUseReadDTO;

export interface EnergyUseDropdownProps {
  diagnosisId?: string;
  /** When multiple is true, value is string[]; otherwise string | null */
  value?: string | string[] | null;
  onChange: (
    value: string | string[] | null,
    option: DiagnosisEnergyUseReadDTO | DiagnosisEnergyUseReadDTO[] | null
  ) => void;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
  fullWidth?: boolean;
  /** Same as MUI Autocomplete multiple: allow selecting multiple options */
  multiple?: boolean;
  /** Se true, mostra l'opzione "Tutti gli usi energetici" (valore all) selezionabile nel dropdown */
  isAllEnergyUseVisible?: boolean;
  /** Quando impostato, mostra solo gli usi energetici con id in questa lista (es. filtrati per vettori selezionati). "Tutti" è mostrato solo se la lista non è vuota. */
  filterOptionIds?: string[] | null;
}

export const EnergyUseDropdown: React.FC<EnergyUseDropdownProps> = ({
  diagnosisId,
  value,
  onChange,
  label = 'Uso Energetico',
  required = false,
  error = false,
  helperText,
  disabled = false,
  fullWidth = true,
  multiple = false,
  isAllEnergyUseVisible = false,
  filterOptionIds = null,
}) => {
  const handleChange = React.useCallback(
    (
      newValue: string | string[] | null,
      option: DiagnosisEnergyUseReadDTO | DiagnosisEnergyUseReadDTO[] | null
    ) => {
      onChange(newValue, option);
    },
    [onChange]
  );

  const prependOptions = React.useMemo(
    () => (isAllEnergyUseVisible ? [ALL_ENERGY_USE_OPTION] : undefined),
    [isAllEnergyUseVisible]
  );

  return (
    <DropdownEntity<DiagnosisEnergyUseReadDTO>
      label={label}
      value={value ?? null}
      queryKey={['diagnosis-energy-use-dropdown', diagnosisId]}
      fetchEntities={() =>
        diagnosisId
          ? apiClient.search_by_diagnosis_id_diagnosis_energy_use_search_by_diagnosis_id__diagnosis_id__get(
              diagnosisId
            )
          : Promise.resolve([])
      }
      getOptionLabel={option => option.code ?? ''}
      getOptionValue={option => option.id ?? ''}
      onChange={handleChange}
      enabled={!!diagnosisId}
      disabled={disabled}
      required={required}
      error={error}
      helperText={helperText}
      placeholder="Seleziona uso energetico"
      fullWidth={fullWidth}
      noOptionsText="Nessun uso energetico disponibile"
      multiple={multiple}
      prependOptions={prependOptions}
      filterOptionIds={filterOptionIds ?? undefined}
    />
  );
};
